module.exports = __webpack_public_path__ + "static/service3-869e3df64bc986cb6b43a04b526f5043.png";